import { BaseDataType } from "src/dataTypes/dataType";
import { Constants } from "src/utils/constants";

import { BaseColumnConfig } from "./baseColumnConfig";

export class GenericTypeColumn<
  T extends BaseDataType<unknown> | undefined
> extends BaseColumnConfig<BaseDataType<unknown> | undefined> {
  identity(value: T) {
    return value?.identity();
  }

  compare(a: T, b: T): number {
    if (a && b) {
      return a?.compare(b);
    }
    return a ? 1 : 0;
  }
  render(val: T) {
    return val?.render() ?? Constants.EMPTY_VALUE;
  }
}
